module.exports = __webpack_public_path__ + "media/images/patent/x_8-8f98e19898b95d126863780573134169.png";